import _ from "lodash";

import { IFormlyConfig, ITypeOptions } from "AngularFormly";
export * from "./controller";
import { RecordFileController } from "./controller";

export function recordFileConfig(formlyConfigProvider: IFormlyConfig) {
  const gridType: ITypeOptions = {
    name: "recordFileUpload",
    template: require("!html-loader!./index.html").default,
    controller: RecordFileController,
  };
  formlyConfigProvider.setType(gridType);
}
recordFileConfig.$inject = ["formlyConfigProvider"];
